var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.8624C0 5.27071 5.27071 0 29.8624 0H34.1651C58.7567 0 64.0275 5.27071 64.0275 29.8624V34.1651C64.0275 58.7567 58.7567 64.0275 34.1651 64.0275H29.8624C5.27071 64.0275 0 58.7567 0 34.1651V29.8624Z",
    fill: "#115E59"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7401,
    cy: 31.7401,
    r: 21.3425,
    stroke: "#14B8A6",
    strokeWidth: 7.66138
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9742 13.9309C14.2034 17.7511 10.3975 24.3011 10.3975 31.7401C10.3975 43.5272 19.9528 53.0826 31.7399 53.0826C43.2522 53.0826 52.6356 43.9677 53.0669 32.5609",
    stroke: "url(#paint0_linear_918_12936)",
    strokeWidth: 7.66138,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9719 27.5271H39.9433C38.7817 27.5462 37.7039 28.5429 37.1722 29.9132C36.5147 31.6046 36.8406 33.458 38.1966 34.0421C38.4405 34.146 38.6988 34.1974 38.9599 34.1974C40.1329 34.1974 41.2278 33.194 41.7643 31.8114C42.418 30.1209 42.0883 28.2665 40.739 27.6834C40.4967 27.5802 40.2352 27.527 39.9719 27.5271Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9969 27.5271H24.0255C25.1871 27.5462 26.2648 28.5429 26.7965 29.9132C27.454 31.6046 27.1281 33.458 25.7722 34.0421C25.5282 34.146 25.27 34.1974 25.0089 34.1974C23.8358 34.1974 22.741 33.194 22.2045 31.8114C21.5508 30.1209 21.8805 28.2665 23.2298 27.6834C23.472 27.5802 23.7336 27.527 23.9969 27.5271Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.249 22.4073L35.2207 22.4114C34.0741 22.5984 33.1519 23.7406 32.8241 25.1734C32.4183 26.9421 33.0089 28.7288 34.4351 29.1106C34.6916 29.1781 34.9545 29.1916 35.2129 29.1539C36.3735 28.9841 37.3117 27.8328 37.6425 26.3871C38.0447 24.6198 37.4501 22.8327 36.0306 22.4509C35.776 22.3839 35.5095 22.3691 35.249 22.4073Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9224 22.103L28.9509 22.106C30.104 22.2472 31.0709 23.3518 31.4555 24.7704C31.9315 26.5216 31.4124 28.3304 30.0025 28.7686C29.749 28.8463 29.4868 28.8703 29.2271 28.8428C28.0606 28.7194 27.0773 27.6064 26.6893 26.1749C26.217 24.4251 26.74 22.6157 28.1432 22.1777C28.3949 22.1006 28.6606 22.0752 28.9224 22.103Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9421 29.9978C30.6843 29.9978 30.0525 30.399 29.1492 31.8312L28.9167 32.2105L28.5403 32.8661C28.4952 32.9466 28.4505 33.0273 28.4059 33.1081C28.1772 33.5217 27.8618 33.8257 27.3205 34.1963L26.7964 34.5442C25.9007 35.1416 25.4319 35.6095 25.1698 36.4071C25.0517 36.7292 24.9831 37.2199 24.9859 37.6268C24.9859 39.2344 26.1275 40.4798 27.6541 40.4798L27.8847 40.4741C27.9981 40.4684 28.1076 40.4579 28.222 40.4417L28.4583 40.4007L28.5841 40.374L28.8614 40.3045L29.0158 40.2616L29.5589 40.0996L30.286 39.868L30.7196 39.7385C31.2246 39.5955 31.6153 39.5269 31.9421 39.5269C32.2699 39.5269 32.6597 39.5965 33.1647 39.7385L33.5983 39.868L34.3263 40.0986L34.8685 40.2616L35.1658 40.3416C35.2583 40.3645 35.344 40.3845 35.426 40.4007L35.6623 40.4417C35.7766 40.4579 35.8862 40.4684 35.9996 40.4741L36.2302 40.4798C37.7568 40.4798 38.8984 39.2344 38.8984 37.6211C38.8984 37.2142 38.8288 36.7263 38.7011 36.3766C38.4762 35.6867 38.056 35.2112 37.2908 34.6328L37.0459 34.4517L36.5428 34.0896C35.931 33.6418 35.587 33.3025 35.3488 32.8718L35.0915 32.4096L34.8514 31.998C33.888 30.3819 33.3096 29.9978 31.9421 29.9978Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_918_12936",
    x1: 14.7754,
    y1: 18.8798,
    x2: 41.3167,
    y2: 57.4605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F7FEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3E635"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.4ca472f0a49065f9a49ad65dd2b76187.svg";
export { ForwardRef as ReactComponent };